import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory } from 'history';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { HelmetProvider } from 'react-helmet-async';
import { Provider as ReduxProvider } from 'react-redux';
import { addIcons } from 'ionicons';
import { searchOutline, searchSharp, closeCircle, closeSharp, arrowBackSharp } from 'ionicons/icons';

import App from './App';
import ErrorBoundaryFallback from './pages/ErrorBoundaryFallback';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import store from './store';

// Ionic built-in icons (searchbar) resolve by name to /svg/*.svg which is not
// deployed — register them as inline data URLs so no runtime fetch happens
addIcons({
  'search-outline': searchOutline,
  'search-sharp': searchSharp,
  'close-circle': closeCircle,
  'close-sharp': closeSharp,
  'arrow-back-sharp': arrowBackSharp,
});

if (process.env.NODE_ENV !== 'development') {
  const history = createBrowserHistory();
  const isDev = process.env.REACT_APP_ENVIRONMENT === 'development';
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENVIRONMENT,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
      }),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: isDev ? 0.5 : 0.2,
  });
}

ReactDOM.render(
  <React.StrictMode>
    <HelmetProvider>
      <Sentry.ErrorBoundary fallback={<ErrorBoundaryFallback />}>
        <ReduxProvider store={store}>
          <App />
        </ReduxProvider>
      </Sentry.ErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
